export default {
    'handle.drag.snap': '拖动磁吸',
    'handle.drag.snap.panel': '边界限制',
    'handle.watermark': '水印',
    'handle.width&height': '宽/高',
    'handle.page.width': '纸张宽',
    'handle.page.height': '纸张高',
    'handle.template.name': '模版名称',
    'handle.please.template.name': '请输入模版名称',
    'handle.formatter': '格式化器',
    'handle.lock.edit': '锁定编辑',
    'handle.border.radius': '圆角边框',
    'handle.opacity': '透明度',
    'handle.rotate': '旋转角度',
    'handle.content.type': '内容类型',
    'handle.barCode.type': '条码类型',
    'handle.barCode.value': '条码值',
    'handle.qrCode.errorCorrectionLevel': '容错级别',
    'handle.qrCode.qrCodeScale': '二维码缩放',
    'handle.qrCode.qrCodeScale.tips': '数字越大越清晰',
    'handle.text.auto.height': '自动高度',
    'handle.line.break': '换行',
    'handle.line.height': '行高',
    'handle.line.width': '线宽',
    'handle.dotted.style': '虚线样式',
    'handle.padding': '内边距',
    'handle.padding.top': '顶内边距',
    'handle.padding.bottom': '底内边距',
    'handle.padding.left': '左内边距',
    'handle.padding.right': '右内边距',
    'handle.top': '顶',
    'handle.bottom': '底',
    'handle.left': '左',
    'handle.right': '右',
    'handle.margin': '外边距',
    'handle.margin.top': '顶外边距',
    'handle.margin.bottom': '底外边距',
    'handle.margin.left': '左外边距',
    'handle.margin.right': '右外边距',
    'handle.fixed.position': '固定位置',
    'handle.clear.canvas': '清空画布',
    'handle.print.strategy': '打印策略',
    'handle.display.strategy': '显示策略',
    'handle.height.attr': '高度属性',
    'handle.table.hidden.head': '隐藏表头',
    'handle.table.page.head': '分页表头',
    'handle.add.statistics.row': '新增统计行',
    'handle.column': '列',
    'handle.table.statistics.type': '统计方式',
    'handle.table.every.page.statistics': '每页统计',
    'handle.table.all.table.statistics': '整表统计'
};
